import Instruction from "./Instruction";

class Prescription {
    constructor(instructions, raw_text) {
      this.instructions = instructions;
      this.raw_text = raw_text
    }

  
    // Method to return user details as an object
    toObject() {
      return {
        instructions: this.instructions,
        raw_text: this.raw_text,
      };
    }
  }
  
  export default Prescription;
  